import React from 'react';
import './AxisEvalTable.css';
// import { debounce } from 'lodash';
import { AxisEvalInfo } from './Utils';
import HoverReveal from './HoverReveal';


type AxisEvalTableProps = {
  data: Array<AxisEvalInfo>,
  dataset: string,
}
type AxisEvalTableState = {
  index: number,
  reveal_all: boolean,
};
class AxisEvalTableComponent extends React.Component<AxisEvalTableProps, AxisEvalTableState> {
  constructor(props: AxisEvalTableProps) {
    super(props);
    this.state = {
      index: Math.floor(Math.random() * this.props.data.length),
      reveal_all: false,
    };
  }

  handleStateChange(event: any) { // KeyboardEvent
    // this.setState({ text: event.target.value });
  }

  changeIndex(incr: number) {
    this.setState({ index: (this.state.index + incr + this.props.data.length) % this.props.data.length });
  }


  // componentDidUpdate(oldProps: AxisEvalTableProps) {
  //   if (oldProps.text !== this.props.text) {
  //     // this.setState({
  //     //   text: this.props.text
  //     // });
  //   }
  // }

  render() {
    const dataset = this.props.dataset;
    const data = this.props.data[this.state.index];
    console.log(data)
    let post_div = (<div>ERROR, UNKNOWN DATASET</div>);
    if (dataset === 'tldr') {
      post_div = (
        <div>
          <b>Reddit Post</b>
          <br/>
          <br/>
          <i>Subreddit</i>: /r/{data.info.subreddit}
          <br/>
          <i>Title</i>: {data.info.title}
          <br/>
          <br/>
            {data.info.post.split('\n').map((item: string, key: number) => {
              return <span key={key}>{item}<br/></span>
            })}
        </div>
      )
    } else if (dataset === 'cnndm') {
      console.log(data.info)
      post_div = (
        <div>
          <b>News Article</b>
          <br/>
          <br/>
          <i>Site</i>: {data.info.site}
          <br/>
          <i>Title</i>: {data.info.title}
          <br/>
          <br/>
            {data.info.article.split('\n').map((item: string, key: number) => {
              return <span key={key}>{item}<br/></span>
            })}
        </div>
      )
    }

    const policies = Object.keys(data.samples);

    return (
      <div className="sample-carousel">
        Keep all human evaluations revealed
        <input type="checkbox" checked={this.state.reveal_all}
          onChange={(e) => this.setState({reveal_all: e.target.checked})}
        />
        <br/>
        <br/>

        <div>
          <button className="sample-next" onClick={() => {this.changeIndex(1)}}>Next &raquo;</button>
          <button className="sample-previous" onClick={() => {this.changeIndex(-1)}}>&laquo; Previous</button>
        </div>
        <div className='sample-table' style={{display: "flex", flexDirection: "row", margin: '10px 0px' }}>
          <div className="table-post" style={{flexBasis: "50%", flexGrow: 0}}>
            {post_div}
          </div>
          <div className="table-summaries" style={{flexBasis: "50%", flexGrow: 0, display: "flex", flexDirection: "column"}}>
            {
              policies.map((name) => {
                const sample = data.samples[name];
                return (
                  <div key={name} style={{display: "flex", flexDirection: "row" }}>
                    <div style={{flexBasis: "50%", flexGrow: 0}} className="table-summary">
                      <b>{name}</b>
                      <br/>
                      <br/>
                      {sample}
                    </div>
                    <div style={{flexBasis: "50%", flexGrow: 0}} className="table-evaluation">
                        <HoverReveal always_revealed={this.state.reveal_all} placeholder="Hover to reveal human judgements">
                          <b>Accuracy</b>: {data.scores.accuracy[name]}
                          <br/>
                          <br/>
                          <b>Coherence</b>: {data.scores.coherence[name]}
                          <br/>
                          <br/>
                          <b>Coverage</b>: {data.scores.coverage[name]}
                          <br/>
                          <br/>
                          <b>Overall</b>: {data.scores.overall[name]}
                          <br/>
                          <br/>
                          <b>Note</b>: {data.notes[name]}
                        </HoverReveal>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="hidden">
          <button className="sample-next" onClick={() => {this.changeIndex(1)}}>Next &raquo;</button>
          <button className="sample-previous" onClick={() => {this.changeIndex(-1)}}>&laquo; Previous</button>
        </div>
      </div>
    );
  }
}

export default AxisEvalTableComponent;
